export const Role = {
    Basic: 'Basic',
    Gold: 'Gold',
    Platinum: 'Platinum'
}